import React from 'react';
import c from 'classnames';
// import { useTranslation } from 'react-i18next';
import s from './InputLabelText.scss';
/**
 * The text of an `<input />`'s label.
 *
 * NOTE: You still need need to wrap this in an `<InputLabel />` tag! This just provides the necessary styling to the text.
 */
var InputLabelText = function (_a) {
    var children = _a.children, className = _a.className, isRequired = _a.isRequired;
    // const { t } = useTranslation();
    return (React.createElement("span", { className: c(s['root'], className) },
        children,
        ' ',
        isRequired && (React.createElement("span", { className: s['required-text'], "aria-hidden": "true" }, "*Required"))));
};
InputLabelText.displayName = 'InputLabelText';
export default InputLabelText;
//# sourceMappingURL=InputLabelText.js.map